import {Component, Input, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {NotificationComponentBase} from '../../_typing/notification';
import {ModelID} from '../../_typing/generic-types';
import {Router, RouterLink} from "@angular/router";
import {COMMON_FORM_IMPORTS} from "../../shared/import-groups/Common";

@Component({
    selector: 'job-notification',
    templateUrl: './job-notification.component.html',
    imports: [
        RouterLink,
        COMMON_FORM_IMPORTS
    ],
    styleUrls: ['./job-notification.component.less']
})
export class JobNotificationComponent extends NotificationComponentBase {
    jobId: ModelID;
    jobType: string;

    constructor(public snackBarRef: MatSnackBarRef<any>,
                @Inject(MAT_SNACK_BAR_DATA) public data: any,
                private router: Router) {
        super(snackBarRef, data);
        this.jobId = data.jobId;
        this.jobType = data.jobType ?? "Task";
    }

    viewJobDetails(event: MouseEvent) {
        event.preventDefault();
        this.router.navigate(['view', 'jobs', this.jobId]);
    }
}
